import WatchButton from './WatchButton';
import WatchButtonContainer from './WatchButton.container';
export default WatchButtonContainer(WatchButton);
//# sourceMappingURL=index.js.map